import { InjectionToken, ValueProvider } from '@angular/core';

export const GET_FABRIC_API_ORIGIN = new InjectionToken<string>('Get Fabric API Origin');
export const provideGetFabricApiOrigin = (origin: string): ValueProvider => ({
  provide: GET_FABRIC_API_ORIGIN,
  useValue: origin,
});
